import { createContext, ReactNode, useContext, useMemo, useState } from "react";

type ContextType = {
  activeOptionId: string | undefined;
  setKeyboardFocusedOptionIndex(index: number | undefined): void;
  listboxId: string;
};

const SelectContext = createContext<ContextType | undefined>(undefined);

export const SelectContextProvider = ({
  id,
  children,
}: {
  id: string;
  children: ReactNode;
}) => {
  const [keyboardFocusedOptionIndex, setKeyboardFocusedOptionIndex] = useState<
    number | undefined
  >(undefined);

  const listboxId = `${id}-select-popup`;

  const contextValue: ContextType = useMemo(
    () => ({
      activeOptionId: keyboardFocusedOptionIndex
        ? `${listboxId}-${keyboardFocusedOptionIndex}`
        : undefined,
      listboxId: listboxId,
      setKeyboardFocusedOptionIndex,
    }),
    [listboxId, keyboardFocusedOptionIndex]
  );

  return (
    <SelectContext.Provider value={contextValue}>
      {children}
    </SelectContext.Provider>
  );
};

export const useSelectContext = (): ContextType => {
  const context = useContext(SelectContext);

  if (context === undefined) {
    // TODO заменить на throw error когда в payments-ui уберут прямое использование Options
    return {
      activeOptionId: "",
      listboxId: "",
      setKeyboardFocusedOptionIndex: () => {},
    };
  }

  return context;
};
